import React from 'react';

import { theme } from '../theme';
import { styled } from '@material-ui/core/styles';

const variants = {
  rounded: {
    borderRadius: '100%',
    color: theme.colors.primary.black,
    '&:hover': {
      backgroundColor: `${theme.colors.primary.white} !important`,
    },
    '&:disabled': {
      color: theme.colors.greyScale.grey3,
      background: 'transparent !important',
      opacity: 0.23,
    },
  },
};

const borderDistance = 30;

const positions = {
  left: () => ({ left: borderDistance }),
  right: (offset, size) => ({ left: offset - borderDistance - size }),
  center: (offset, size) => ({ left: (offset - size) / 2 }),
};

const CustomIconButton = styled('div')(
  ({
    variant = 'rounded',
    size = 64,
    floatElevation = true,
    offset = 0,
    position = 'right',
    isvisible = false,
  }) => ({
    height: size,
    width: size,
    padding: '8px',
    cursor: isvisible ? 'pointer' : 'deafult',
    position: 'fixed',
    bottom: 90,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: theme.colors.primary.white,
    opacity: isvisible ? 1.0 : 0,
    transition: '.15s ease-in-out',
    zIndex: 20,
    WebkitTapHighlightColor: 'transparent',
    ...(floatElevation && {
      boxShadow: '-1px 6px 13px 0px rgba(0,0,0,0.44)',
    }),
    ...(!isvisible && {
      pointerEvents: 'none',
    }),
    ...variants[variant],
    ...positions[position](offset, size),
  })
);

const CustomButton = ({ children, ...rest }, ref) => (
  <CustomIconButton ref={ref} {...rest}>
    <div>{children}</div>
  </CustomIconButton>
);

CustomButton.displayName = 'SdmFloatingActionButton';

export const SdmFloatingActionButton = React.forwardRef(CustomButton);
